import { useDomainAccessControl } from '../domain/accessControl'
import { FeatureToggle } from '../../access-control/featureToggles'

export const useElementTrackingEnabled = (): boolean => {
  const hasAccess = useDomainAccessControl()

  return hasAccess({ featureToggles: [FeatureToggle.elementTrackingEnabled] })
}
